import React, { Component } from 'react';
import Modal from 'react-modal';
import '../index.css';

/**
 * Displays URL-failure telemetry details (fetched from Cosmos DB) for a
 * selected ARP metric cell. The popup theme (orange / red) mirrors the
 * severity of the clicked metric so the visual context is preserved.
 */
export default class TelemetryDetailModal extends Component {
    displayName = TelemetryDetailModal.name;

    render() {
        const {
            isOpen,
            onRequestClose,
            severity,        // 'orange' | 'red'
            appname,
            service,
            component,
            dsmService,
            metricType,
            metricValue,
            environment,
            loading,
            error,
            details,           // array of UrlFailureInsight records
            timeRange          // optional aggregated time-range label (Hourly view)
        } = this.props;

        const themeClass = severity === 'red' ? 'tdm-theme-red' : 'tdm-theme-orange';
        const rows = Array.isArray(details) ? details : [];

        return (
            <Modal
                isOpen={isOpen}
                onRequestClose={onRequestClose}
                ariaHideApp={false}
                contentLabel="Telemetry Details"
                className={`tdm-modal ${themeClass}`}
                overlayClassName="tdm-overlay"
            >
                <div className="tdm-header">
                    <div className="tdm-header-title">
                        <span className="tdm-metric-name">{metricType || 'Metric'}</span>
                        {metricValue !== undefined && metricValue !== null && metricValue !== '' ? (
                            <span className="tdm-metric-value">{metricValue}%</span>
                        ) : null}
                    </div>
                    <button className="tdm-close" onClick={onRequestClose} aria-label="Close">×</button>
                </div>

                <div className="tdm-context">
                    {dsmService ? <div><span className="tdm-label">DSM Service:</span> {dsmService}</div> : null}
                    {service ? <div><span className="tdm-label">Service:</span> {service}</div> : null}
                    {component ? <div><span className="tdm-label">Component:</span> {component}</div> : null}
                    {appname ? <div><span className="tdm-label">App:</span> {appname}</div> : null}
                    {environment ? <div><span className="tdm-label">Environment:</span> {environment}</div> : null}
                </div>

                <div className="tdm-body">
                    {loading ? (
                        <div className="tdm-loading">Loading telemetry details…</div>
                    ) : error ? (
                        <div className="tdm-error">Unable to load telemetry details. Please try again later.</div>
                    ) : rows.length === 0 ? (
                        <div className="tdm-empty">No URL failure telemetry found for this selection.</div>
                    ) : (
                        <div className="tdm-url-list">
                            {rows.map((item, idx) => (
                                <div className="tdm-url-card" key={item.id || idx}>
                                    <div className="tdm-url-top">
                                        {item.HttpMethod ? <span className="tdm-http-method">{item.HttpMethod}</span> : null}
                                        <span className="tdm-url-text" title={item.Url}>
                                            {item.Url}
                                        </span>
                                    </div>
                                    <div className="tdm-url-meta">
                                        {item.FailureType ? <span className="tdm-badge">{item.FailureType}</span> : null}
                                        <span className="tdm-badge tdm-badge-count">Failures: {item.FailureCount}</span>
                                        {timeRange
                                            ? <span className="tdm-meta-item">Time: {timeRange}</span>
                                            : (item.Timestamp ? <span className="tdm-meta-item">Time: {item.Timestamp}</span> : null)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </Modal>
        );
    }
}
